import React from 'react'
import { getBaseButtonClasses } from '../../utils/socialButtonStyles'
import { LoadingSpinner } from './SocialIcons'

const SocialButton = ({
  icon: Icon,
  children,
  onClick,
  variant,
  size = 'md',
  className = '',
  disabled = false,
  isLoading = false,
  style = {},
  loadingText = 'Signing in...',
  loadingSpinnerColor = 'border-purple-600'
}) => {
  const buttonClasses = getBaseButtonClasses(size, variant, className, disabled, isLoading)

  return (
    <button
      type="button"
      className={buttonClasses}
      onClick={() => onClick(disabled)}
      disabled={disabled || isLoading}
      style={style}
    >
      <Icon />

      <span className="font-medium">
        {isLoading ? (
          <>
            <LoadingSpinner color={loadingSpinnerColor} />
            {loadingText}
          </>
        ) : (
          children
        )}
      </span>
    </button>
  )
}

export default SocialButton